import "./ForgotPassword.css";
import { useEffect, useRef } from "react";
import { useState } from "react";
import { FaInfoCircle } from "react-icons/fa";
import { handleToastPromiseError, initFooterBtns } from "../../../utils/utilsFuncs";
import toast from "react-hot-toast";
import { doPost } from "../../../utils/HTTPRequests";
import { validate } from "../../../utils/FormValidation";
import { globals } from "../../../utils/Globals";
import Captcha from "../../../utils/Captcha/Captcha";

function ForgotPassword({ usernameFromLoginScreen, setShowForgotPasswordModal }) {
  const [username, setUsername] = useState(usernameFromLoginScreen);
  const [captchaValue, setCaptchaValue] = useState(null);

  const sendButtonRef = useRef();

  const rules = {
    username: { object: username, messageName: "Username", required: true },
    captchaValue: { object: captchaValue, messageName: "Captcha", required: true },
  };

  const resetPassword = async () => {
    if (validate(rules)) {
      // Disable the send btn to prevent double click
      sendButtonRef.current.setAttribute("disabled", true);

      await toast.promise(
        doPost(
          globals.user.forgotPassword,
          {
            username: username,
            captchaValue: captchaValue,
          },
          true
        ),
        {
          loading: "Reset password...",
          success: <b>Reset password finished successfully. Please check your email.</b>,
          error: (err) => {
            sendButtonRef.current.removeAttribute("disabled");
            return handleToastPromiseError(err);
          },
        }
      );
    } else {
      throw new Error("Validation Error");
    }
  };

  useEffect(() => {
    initFooterBtns("modal-footer-ForgotPassword", ["forgot-password-send-btn"]);
  }, []);

  return (
    <>
      <button
        id="forgot-password-send-btn"
        ref={sendButtonRef}
        style={{ display: "none" }}
        className="footer-save-modal-btn"
        onClick={() => {
          resetPassword()
            .then(() => {
              setShowForgotPasswordModal(false);
            })
            .catch((error) => {
              console.log(error);
            });
        }}
      >
        Send
      </button>
      <div className="ForgotPassword">
        <div className="forgot-password-text">
          The system will send temporary password valid for 3 hours via E-mail associated with your user.
        </div>
        <div className="form-item">
          <label>* User Name:</label>
          <div className="modal-input-container">
            <input
              name="username"
              className="modal-input"
              type="text"
              value={username}
              onChange={(e) => {
                setUsername(e.target.value);
              }}
            />
            <FaInfoCircle className="modal-input-icon" />
          </div>
        </div>
        <Captcha setCaptchaValue={setCaptchaValue} />
      </div>
    </>
  );
}
export default ForgotPassword;
